module.exports = __webpack_public_path__ + "static/media/YellowStar.52adb0fc.svg";